// Labels every team profile shares, German: section titles, row labels, downloads, contact, PDF sections.
module.exports = {
  personal: {
    title: 'Daten zur Person',
    rows: {
      name: 'Name',
      position: 'Funktion',
      birthdate: 'Geburtsdatum',
      nationality: 'Staatsangehörigkeit',
      maritalStatus: 'Zivilstand',
      location: 'Standort',
      languages: 'Sprachen',
      programmingLanguages: 'Programmiersprachen',
      certifications: 'Zertifizierungen',
      publications: 'Publikationen',
      links: 'Website'
    }
  },
  education: {
    title: 'Ausbildung'
  },
  skills: {
    title: 'Spezialkenntnisse'
  },
  experience: {
    title: 'Projekte und Tätigkeiten',
    techLabel: 'Technologien'
  },
  downloads: {
    title: 'Profil herunterladen',
    deLabel: 'Deutsches Profil herunterladen',
    deDescription: 'PDF auf Deutsch',
    enLabel: 'English CV herunterladen',
    enDescription: 'PDF auf Englisch'
  },
  cta: {
    title: 'Kontakt',
    button: 'Kontakt aufnehmen'
  },
  pdf: {
    title: 'Profil',
    pageNumber: 'Seite {page} von {pages}',
    phoneLabel: 'Tel.',
    managingDirectors: 'Geschäftsführer',
    personalSection: 'Daten zur Person',
    educationSection: 'Ausbildung',
    experienceSection: 'Projekte und Tätigkeiten',
    skillsLabel: 'Spezialkenntnisse',
    personalLabels: {
      nationality: 'Nationalität',
      programmingLanguages: 'Programmierung'
    }
  }
};
